import React from 'react';
import PropTypes from 'prop-types';
import { SingleSelect } from '@els/els-react--select';

import './FrequencyRow.scss';

function FrequencyRow({
  alertsInfo,
  alertFormFrequency,
  setAlertFormFrequency,
  alertFormDayOfWeek,
  setAlertFormDayOfWeek,
  alertFormDayOfMonth,
  setAlertFormDayOfMonth,
  alertFormDayOfWeekAvailable,
  alertFormDayOfMonthAvailable,
}) {
  const { frequencies, daysOfWeek, daysOfMonth } = alertsInfo;
  const handleSelectFrequency = (value) => {
    setAlertFormFrequency(value);
  };
  const handleSelectDayOfWeek = (value) => {
    setAlertFormDayOfWeek(value);
  };
  const handleSelectDayOfMonth = (value) => {
    setAlertFormDayOfMonth(value);
  };

  return (
    <div className="create-alert-dialog-row create-alert-dialog-row-frequency">
      <div className="create-alert-dialog-column-label">Frequency:</div>
      <div className="create-alert-dialog-column-content u-els-padding-top">
        <SingleSelect
          id="create-alert-dialog-frequency-dropdown"
          className="create-alert-frequency e2e-create-alert-frequency u-els-margin-right"
          options={frequencies}
          data-e2e="create-alert-frequency-dropdown"
          selectedOptions={alertFormFrequency ? [alertFormFrequency] : undefined}
          label="Frequency"
          required
          onSelect={handleSelectFrequency}
          size="small"
          shouldHideLabel
        />
        {alertFormDayOfWeekAvailable && (
          <>
            <span className="create-alert-dialog-frequency-on">on:</span>
            <SingleSelect
              id="create-alert-dialog-day-of-week-dropdown"
              className="create-alert-day-of-week e2e-create-alert-day-of-week"
              options={daysOfWeek}
              data-e2e="create-alert-day-of-week-dropdown"
              selectedOptions={alertFormDayOfWeek ? [alertFormDayOfWeek] : undefined}
              label="On day of week"
              required
              onSelect={handleSelectDayOfWeek}
              size="small"
              shouldHideLabel
            />
          </>
        )}
        {alertFormDayOfMonthAvailable && (
          <>
            <span className="create-alert-dialog-frequency-on">on the:</span>
            <SingleSelect
              id="create-alert-dialog-day-of-month-dropdown"
              className="create-alert-day-of-month e2e-create-alert-day-of-month"
              options={daysOfMonth}
              data-e2e="create-alert-day-of-month-dropdown"
              selectedOptions={alertFormDayOfMonth ? [alertFormDayOfMonth] : undefined}
              label="On day of month"
              required
              onSelect={handleSelectDayOfMonth}
              size="small"
              shouldHideLabel
            />
          </>
        )}
      </div>
    </div>
  );
}

FrequencyRow.propTypes = {
  alertsInfo: PropTypes.object.isRequired,
  alertFormFrequency: PropTypes.string,
  setAlertFormFrequency: PropTypes.func.isRequired,
  alertFormDayOfWeek: PropTypes.string,
  setAlertFormDayOfWeek: PropTypes.func.isRequired,
  alertFormDayOfMonth: PropTypes.string,
  setAlertFormDayOfMonth: PropTypes.func.isRequired,
  alertFormDayOfWeekAvailable: PropTypes.bool,
  alertFormDayOfMonthAvailable: PropTypes.bool,
};

export default FrequencyRow;
